/**
 * Runtime config bootstrap (D11 layer 1) — fetched from /config.json at boot so
 * deploys never require an `.env.prod` rebuild to point the portal at a realm,
 * client id, or app registry entry. See sso-portal/README.md D11 and A5.1.
 */
export interface PortalAppConfig {
    name: string;
    apiBase: string;
    webUrl: string;
}

export interface RuntimeConfig {
    authority: string;
    clientId: string;
    /** EAA-1756: portal-api base URL (serves `/api/v1/me/access`). */
    apiBase: string;
    apps: Record<string, PortalAppConfig>;
    /**
     * EAA-1765: allowed ORIGINS the portal may bounce a user back to after login
     * (`/login?returnTo=…`). Open-redirect protection — a `returnTo` whose origin
     * is not here is ignored (falls back to the launcher). Omitted ⇒ external
     * returns are refused entirely (portal-internal navigation only).
     */
    returnToAllowlist?: string[];
}

let cached: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
    if (cached) return cached;
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (!res.ok) {
        throw new Error(`Failed to load /config.json: ${res.status}`);
    }
    cached = (await res.json()) as RuntimeConfig;
    return cached;
}
